import FormHiddenInput from './FormHiddenInput';

export default FormHiddenInput;
